export default class Cart
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Cart.prototype.defaults, ...options }
        this.init()
    }

    formatPrice(price) {
        return this.formatter.format(price)
    }

    init() {
        // Cache DOM elements
        this.DOM.$$product = this.DOM.$el.querySelectorAll(this.options.selectorProduct)
        this.DOM.$discount = this.DOM.$el.querySelector(this.options.selectorDiscount)
        this.DOM.$showProducts = this.DOM.$el.querySelector(this.options.selectorShowProducts)
        this.DOM.$showPromoCode = this.DOM.$el.querySelector(this.options.selectorShowPromoCode)
        this.DOM.$showVATNumber = this.DOM.$el.querySelector(this.options.selectorShowVatNumber)
        this.DOM.$promoCodeInput = this.DOM.$el.querySelector(this.options.selectorPromoCodeInput)
        this.DOM.$promoCodeSubmit = this.DOM.$el.querySelector(this.options.selectorPromoCodeSubmit)
        this.DOM.$vatNumberInput = this.DOM.$el.querySelector(this.options.selectorVatNumberInput)
        this.DOM.$vatNumberSubmit = this.DOM.$el.querySelector(this.options.selectorVatNumberSubmit)
        this.DOM.$total = this.DOM.$el.querySelector(this.options.selectorTotal)
        this.DOM.$vat = this.DOM.$el.querySelector(this.options.selectorVat)

        this.discounts = []
        this.updateUrl = this.DOM.$el.dataset[this.options.attrUpdateUrl]
        this.vatPercentage = parseInt(this.DOM.$el.dataset[this.options.attrVatPercentage], 10)
        this.formatter = new Intl.NumberFormat("en-UK", {
            style: "currency",
            currency: this.DOM.$el.dataset[this.options.attrEventCurrency],
            useGrouping: "min2",
            roundingMode: "floor",
        })
        this.initDiscounts()


        if (this.DOM.$showProducts) {
            // Show other available products
            this.DOM.$showProducts.addEventListener('click', (e) => {
                e.preventDefault()
                this.DOM.$el.classList.add(this.options.classNameIsShowProducts)
            })
        }

        if (this.DOM.$showPromoCode) {
            // Show promo code input
            this.DOM.$showPromoCode.addEventListener('click', (e) => {
                e.preventDefault()
                this.DOM.$el.classList.add(this.options.classNameIsShowPromoCode)
                this.DOM.$promoCodeInput.focus()
            })

            // Handle promo code submit
            this.DOM.$promoCodeInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    this.submitPromoCode()
                    e.preventDefault()
                    e.stopPropagation()
                }
            })
            this.DOM.$promoCodeSubmit.addEventListener('click', this.submitPromoCode.bind(this))
        }

        if (this.DOM.$showVATNumber) {
            // Show VAT Number input
            this.DOM.$showVATNumber.addEventListener('click', (e) => {
                e.preventDefault()
                this.DOM.$el.classList.add(this.options.classNameIsShowVatNumber)
                this.DOM.$vatNumberInput.focus()
            })

            // Handle VAT Number submit
            this.DOM.$vatNumberInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    this.submitVatNumber()
                    e.preventDefault()
                    e.stopPropagation()
                }
            })
            this.DOM.$vatNumberSubmit.addEventListener('click', this.submitVatNumber.bind(this))
        }

        // Init input event handler for quantity fields
        this.DOM.$$product.forEach($product => {
            let $quantity = $product.querySelector(this.options.selectorProductQuantity)

            if ($quantity) {
                $quantity.addEventListener('change', this.onUpdateProductQuantity.bind(this))
            }
        })

        // Initialize
        this.updateTotals(false)
    }

    initDiscounts() {
        let discounts = this.DOM.$el.dataset[this.options.attrDiscounts]

        if (discounts) {
            // Discount syntax: percentage:elegible_product_ids
            // Product IDs are separated with a ,
            // Discounts are separated with a |
            discounts.split('|').forEach(discount => {
                let [ value, ids ] = discount.split(':')
                let type = value.match(/\d+%$/) ? 'percentage' : 'absolute'

                this.discounts.push({
                    ids: (ids === '*') ? '*' : ids.split(','),
                    type,
                    value: parseInt(value.replace('%', ''), 10),
                })
            })
        }
    }

    onUpdateProductQuantity() {
        this.updateTotals()
    }

    submitPromoCode() {
        const promoCode = this.DOM.$promoCodeInput.value
        const redirect = new URL(window.location.href)

        if (promoCode.length) {
            redirect.searchParams.set('code', promoCode)
            window.location = redirect.href
        }
    }

    submitVatNumber() {
        const vatNumber = this.DOM.$vatNumberInput.value
        const redirect = new URL(window.location.href)
        if (this.DOM.$vatNumberInput.checkValidity()) {
            redirect.searchParams.set('vat_number', vatNumber)
            window.location = redirect.href
        }
    }

    updateTotals(submit = true) {
        let total = 0
        let totalDiscount = 0
        let taxable = 0

        if (submit) {
            // Submit form to server to sync session data
            axios.post(this.updateUrl, new FormData(this.DOM.$el))
        }

        // Iterate over cart products
        this.DOM.$$product.forEach($product => {
            let $productQuantity = $product.querySelector(this.options.selectorProductQuantity)
            let $productTotal = $product.querySelector(this.options.selectorProductTotal)
            let $productTotalBeforeDiscount = $product.querySelector(this.options.selectorProductTotalBeforeDiscount)

            let id = $product.dataset[this.options.attrProductId]
            let price = parseInt($product.dataset[this.options.attrProductPrice], 10)
            let product_vat = parseInt($product.dataset[this.options.attrProductVat], 10)

            if ($productQuantity) {
                let qty = parseInt($productQuantity.value, 10)
                let productDiscount = 0
                let productTotal = price * qty
                let productTotalAfterDiscount = price * qty

                // Iterate over applied discounts
                this.discounts.forEach(discount => {
                    // Check if discount applies to current product
                    if (discount.ids === '*' || discount.ids.indexOf(id) > -1) {
                        switch (discount.type) {
                            case 'absolute':
                                productDiscount = discount.value
                                break

                            case 'percentage':
                                productDiscount = productTotal * (discount.value / 100)
                                break
                        }
                    }
                })

                if ($productTotalBeforeDiscount) {
                    $productTotalBeforeDiscount.innerText = this.formatPrice(productTotal)
                }

                productTotalAfterDiscount = _.clamp((productTotal - productDiscount), 0, productTotal)

                if ($productTotal) {
                    $productTotal.innerText = this.formatPrice(productTotalAfterDiscount)
                }

                total += productTotalAfterDiscount
                totalDiscount += productDiscount
                taxable = product_vat ? productTotalAfterDiscount : 0;
            }
        })

        let vat = (taxable * (this.vatPercentage / 100))

        // Update VAT and total values in table
        if(this.DOM.$vat){
            this.DOM.$vat.innerText = this.formatPrice(vat)
        }
        this.DOM.$total.innerText = this.formatPrice(total + vat)

        // Update discount value in table if present
        if (this.DOM.$discount) {
            this.DOM.$discount.innerText = this.formatPrice(totalDiscount)
        }
    }
}

Cart.prototype.defaults = {
    attrDiscounts: 'cartDiscounts',
    attrProductId: 'cartProductId',
    attrProductPrice: 'cartProductPrice',
    attrProductVat: 'cartProductVat',
    attrUpdateUrl: 'cartUpdateUrl',
    attrAdminOrder: 'adminOrder',
    attrVatPercentage: 'cartVatPercentage',
    attrEventCurrency: 'cartCurrency',
    classNameIsShowProducts: 'is-showProducts',
    classNameIsShowPromoCode: 'is-showPromoCode',
    classNameIsShowVatNumber: 'is-showVatNumber',
    selectorDiscount: '.js-cartDiscount',
    selectorProduct: '.js-cartProduct',
    selectorProductQuantity: '.js-cartProductQuantity',
    selectorProductTotal: '.js-cartProductTotal',
    selectorProductTotalBeforeDiscount: '.js-cartProductTotalBeforeDiscount',
    selectorPromoCodeInput: '.js-cartPromoCodeInput',
    selectorPromoCodeSubmit: '.js-cartPromoCodeSubmit',
    selectorVatNumberInput: '.js-cartVatNumberInput',
    selectorVatNumberSubmit: '.js-cartVatNumberSubmit',
    selectorShowProducts: '.js-cartShowProducts',
    selectorShowPromoCode: '.js-cartShowPromoCode',
    selectorShowVatNumber: '.js-cartShowVatNumber',
    selectorTotal: '.js-cartTotal',
    selectorVat: '.js-cartVat',
}